import axios from 'axios';
import actions from './actions';
import { appOperations } from '../../../../../App/store';
import ColoredSnackbarConstants from '../../../../misc/ColoredSnackbar/ColoredSnackbarConstants';

const { setUsers, setTotalCount, setLoading } = actions;
const { openSnack } = appOperations;

const fetchUsers = () => async (dispatch, getState) => {
    const { page, rowsPerPage, searchTerm } = getState().usersPage;
    
    dispatch(setLoading(true));
    
    try {
        const response = await axios.get('/api/admin/Users/GetUsersList', {
            params: {
                pageNumber: page + 1, 
                pageSize: rowsPerPage,
                searchPhrase: searchTerm || null
            }
        });

        const { items, total } = response.data;

        dispatch(setUsers(items || []));
        dispatch(setTotalCount(total || 0));

    } catch (error) {
        console.error("Error fetching users:", error);
        dispatch(openSnack('Failed to fetch users', ColoredSnackbarConstants.SNACKBAR_ERROR));
    } finally {
        dispatch(setLoading(false));
    }
};

export default { fetchUsers };